var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 398.67 398.67"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 199.34,
  cy: 199.34,
  r: 199.34,
  style: {
    fillOpacity: 0
  },
  fill: "none"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M284.07 111.86c-15.01-9.79-25.85-25.45-29.23-43.71-.73-3.95-1.13-8.01-1.13-12.16h-47.92l-.08 192.04c-.81 21.51-18.5 38.77-40.2 38.77-6.74 0-13.09-1.69-18.68-4.63-12.82-6.75-21.6-20.19-21.6-35.65 0-22.21 18.07-40.28 40.28-40.28 4.15 0 8.12.68 11.89 1.86v-48.92c-3.89-.53-7.85-.86-11.89-.86-48.63 0-88.2 39.57-88.2 88.2 0 29.84 14.91 56.25 37.65 72.21 14.33 10.06 31.75 15.98 50.55 15.98 48.63 0 88.2-39.56 88.2-88.2v-97.38c18.79 13.49 41.82 21.44 66.67 21.44v-47.92c-13.38 0-25.85-3.98-36.3-10.8Z"
})));
export default SvgTiktok;